import { Card, Text } from '@percent/lemonade'
import styles from './OrganisationCard.module.scss'
import { OrganisationCardProps } from './OrganisationCard.types'

export function OrganisationCard({ website, name, logo }: Readonly<OrganisationCardProps>) {
  return (
    <Card>
      <div className={styles.container}>
        <div className={styles.textWrapper}>
          <Text size="large" fontWeight="bold" dataTestId="title">
            {name}
          </Text>
          {website && (
            <div className={styles.websiteCtn}>
              <span className={styles.websiteWrapper}>
                <Text color="#8a4aff" dataTestId="website">
                  {<a href={website}> {website} </a>}
                </Text>
              </span>
            </div>
          )}
        </div>
        {logo && (
          <div>
            <img src={logo} alt="organisation logo" className={styles.image} data-testid="logo" />
          </div>
        )}
      </div>
    </Card>
  )
}
